<template>
  <v-card
    id="cardIdComponente"
    class="mx-auto"
    :max-width="width"
    outlined
  >
    <div class="card-header-dashbord">
      <v-row>
        <v-col
          cols="12"
          sm="10"
          md="10"
          lg="10"
          class="d-flex flex-wrap"
        >
          {{ text }}
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          lg="2"
          class="d-flex justify-end"
        >
          <v-tooltip
            v-if="exibirInformacao"
            top
            class="text-right"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                id="iconInformation"
                class="text-right"
                v-bind="attrs"
                v-on="on"
                @mouseover="enableText(codeInformation)"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <div
              v-if="codigo === codeInformation"
              v-html="textoOrientacao"
            />
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
    <br><br>
    <v-card-actions>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <template v-if="componenteValor">
            <v-container>
              <div>
                <div
                  v-if="loading"
                  :style="styleObject"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <div
                  v-else
                >
                  <v-row v-if="componenteValorColuna">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="d-flex flex-column align-items-end"
                    >
                      <v-row
                        v-if="valorFaturamentoIcmsst"
                        style="margin: -3rem 0 0 0rem;"
                      >
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="text-left"
                        >
                          <v-row
                            id="mesAtual"
                            :style="styleObject"
                          >
                            <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              lg="4"
                              class="text-left"
                            >
                              Faturamento
                            </v-col>
                            <v-col
                              cols="12"
                              sm="8"
                              md="8"
                              lg="8"
                              class="text-right"
                            >
                              {{ valor }}
                            </v-col>
                          </v-row>
                          <v-row
                            id="mesAtual"
                            :style="styleObject2"
                          >
                            <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              lg="4"
                              class="text-left"
                            >
                              ICMS-ST
                            </v-col>
                            <v-col
                              cols="12"
                              sm="8"
                              md="8"
                              lg="8"
                              class="text-right"
                            >
                              {{ valor2 }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <div v-else>
                        <div
                          id="valor1"
                          :style="styleObject"
                          class="text-right"
                        >
                          {{ valor }}
                        </div>
                        <div
                          id="valor2"
                          :style="styleObject2"
                          class="text-right mt-1"
                        >
                          {{ valor2 }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        id="valor"
                        :style="styleObject"
                        class="text-right"
                      >
                        <v-row v-if="exibirIcone">
                          <v-col
                            cols="12"
                            sm="11"
                            md="11"
                            lg="11"
                          >
                            {{ valor }}
                          </v-col>
                          <v-col
                            cols="12"
                            sm="1"
                            md="1"
                            lg="1"
                          >
                            <span>
                              <router-link
                                :to="linkDetalhe"
                                :style="styleObject"
                              >
                                <v-icon>
                                  mdi-arrow-top-right-bold-box-outline
                                </v-icon><br>
                              </router-link>
                            </span>
                          </v-col>
                        </v-row>
                        <v-row
                          v-else-if="exibirDetalheFinanceiro"
                          class="align-center"
                        >
                          <v-col
                            cols="10"
                            sm="10"
                            md="10"
                            lg="10"
                          >
                            {{ valor }}
                          </v-col>
                          <v-col
                            cols="2"
                            sm="2"
                            md="2"
                            lg="1"
                          >
                            <router-link
                              :to="linkDetalhe"
                              :style="styleObject"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </router-link>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            {{ valor }}
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-container>
          </template>
          <template v-if="componenteValorFaturamento">
            <v-container>
              <div>
                <div
                  v-if="loading"
                  :style="styleObject"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <div
                  v-else
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        id="valor"
                        :style="styleObject"
                        class="text-center"
                        style="margin: -3rem 0 0 0rem;"
                      >
                        <v-row class="text-center">
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            class="text-left"
                          >
                            <v-row id="mesAtual">
                              <v-col
                                cols="12"
                                sm="4"
                                md="4"
                                lg="4"
                                class="text-left"
                              >
                                Atual
                              </v-col>
                              <v-col
                                cols="12"
                                sm="8"
                                md="8"
                                lg="8"
                                class="text-right"
                              >
                                {{ valor }}
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            class="text-left"
                          >
                            <v-row id="mesAnterior">
                              <v-col
                                cols="12"
                                sm="4"
                                md="4"
                                lg="4"
                                class="text-left"
                              >
                                Mês Anterior
                              </v-col>
                              <v-col
                                v-if="exibirValorPorcentagem"
                                cols="12"
                                sm="8"
                                md="8"
                                lg="8"
                                class="text-right"
                              >
                                {{ valor2 }} ({{ valor4 }}%)
                              </v-col>
                              <v-col
                                v-else
                                cols="12"
                                sm="8"
                                md="8"
                                lg="8"
                                class="text-right"
                              >
                                {{ valor2 }}
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            class="text-left"
                          >
                            <v-row id="mesAnterior">
                              <v-col
                                cols="12"
                                sm="4"
                                md="4"
                                lg="4"
                                class="text-left"
                              >
                                Ano Anterior
                              </v-col>
                              <v-col
                                v-if="exibirValorPorcentagem"
                                cols="12"
                                sm="8"
                                md="8"
                                lg="8"
                                class="text-right"
                              >
                                {{ valor3 }} ({{ valor5 }}%)
                              </v-col>
                              <v-col
                                v-else
                                cols="12"
                                sm="8"
                                md="8"
                                lg="8"
                                class="text-right"
                              >
                                {{ valor3 }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-container>
          </template>
          <template
            v-if="componenteDiasUteis"
          >
            <div>
              <div
                v-if="loading"
                :style="styleObject"
              >
                <v-icon
                  light
                  class="custom-loader"
                  :style="styleObject"
                >
                  mdi-cached
                </v-icon>
                Carregando dados...
              </div>
              <div
                v-else-if="error"
                class="alert alert-danger"
              >
                {{ error }}
              </div>
              <div
                v-else
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <div
                              id="textoDias"
                              class="text-center"
                            >
                              Dias Úteis
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <div
                              id="diasUteis"
                              class="text-center"
                              :style="styleObject"
                            >
                              {{ diasUteis }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <div
                              id="textoDiasTrabalhado"
                              class="text-center"
                            >
                              Dias trabalhados
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <div
                              id="diasUteis"
                              class="text-center"
                              :style="styleObject"
                            >
                              {{ diasPecorrido }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </div>
          </template>
          <template v-if="componenteGrafico">
            <v-container>
              <div>
                <div
                  v-if="loading"
                  :style="styleObject"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <div>
                  <div
                    v-if="enableGraficoValorMonetario"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <canvas
                          :id="graficoId"
                          class="text-center"
                          width="70"
                          height="50"
                        />
                        <div
                          v-if="lengendaValorMoterio"
                        >
                          <div v-if="valorExibicao">
                            <span
                              id="valorExibicao"
                              :style="styleObjectvalorRestante"
                            >
                              {{ valorExibicao }}
                            </span>
                            <span v-if="valorRestante">
                              <span
                                id="valorRestanteExibicao"
                                :style="styleObjectvalorRestante"
                              >
                                {{ valorRestante }}
                              </span>
                              <span id="spanValorRestanteExibicao">
                                *Até o final do mês
                              </span>
                            </span>
                          </div>
                          <div v-else>
                            <span v-if="valorRestante">
                              <span
                                id="valorRestante"
                                :style="styleObjectvalorRestante"
                              >
                                {{ valorRestante }}
                              </span>
                              <span id="spanValorRestante">
                                *Até o final do mês
                              </span>
                            </span>
                          </div>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <canvas
                          :id="graficoId2"
                          class="text-center"
                          width="70"
                          height="50"
                        />
                        <div
                          v-if="lengendaValorMoterio"
                        >
                          <div v-if="valorExibicao2">
                            <span
                              id="valorExibicao"
                              :style="styleObjectvalorRestante"
                            >
                              {{ valorExibicao2 }}
                            </span>
                            <span v-if="valorRestante2">
                              <span
                                id="valorRestanteExibicao"
                                :style="styleObjectvalorRestante"
                              >
                                {{ valorRestante2 }}
                              </span>
                              <span id="spanValorRestanteExibicao">
                                *Até o final do mês
                              </span>
                            </span>
                          </div>
                          <div v-else>
                            <span v-if="valorRestante2">
                              <span
                                id="valorRestante"
                                :style="styleObjectvalorRestante"
                              >
                                {{ valorRestante2 }}
                              </span>
                              <span id="spanValorRestante">
                                *Até o final do mês
                              </span>
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else>
                    <canvas
                      :id="graficoId"
                      class="text-center"
                      width="70"
                      height="50"
                    />
                    <span
                      v-if="exibirDadosGrafico"
                      :id="dadosGraficoId"
                      class="text-center"
                    >
                      {{ dadosGrafico }}
                    </span>
                    <div
                      v-if="exibirLegenda"
                      id="legendaAberta"
                      class="text-center px-3"
                    >
                      <v-row
                        align="center"
                        class="ma-0"
                        no-gutters
                      >
                        <v-col
                          md="12"
                          offset-md="1"
                        >
                          <v-row>
                            <div
                              v-for="status in legendaGrafico"
                              :key="status.status"
                            >
                              <v-avatar
                                class="mr-1"
                                :color="status.cor"
                                size="12"
                              />
                              <span
                                :id="'statusCor'"
                                class="mr-3 font-weight-light"
                              >{{ status.status }}</span>
                            </div>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                    <div v-if="exibirDadosClientes">
                      <div
                        v-if="loading"
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                      <div
                        v-else-if="error"
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                      <div
                        v-else
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            class="text-center"
                          >
                            <span
                              id="positivados"
                              :style="stylePositivados"
                            >
                              <router-link
                                :to="routerLinkPositivados"
                                :style="styleObject"
                              >
                                <v-icon>
                                  mdi-arrow-top-right-bold-box-outline
                                </v-icon><br>
                              </router-link>
                              {{ totalPositivados }}
                            </span><br>
                            {{ textPositivados }}
                          </v-col>
                          <v-col
                            cols="12"
                            class="text-center"
                          >
                            <span
                              id="positivados"
                              :style="stylePositivados"
                            >
                              <router-link
                                :to="routerLinkAtivos"
                                :style="styleObject"
                              >
                                <v-icon>
                                  mdi-arrow-top-right-bold-box-outline
                                </v-icon><br>
                              </router-link>
                              {{ totalAtivos }}
                            </span><br>
                            {{ textAtivos }}
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
          </template>
          <template v-if="componenteAuxiliar">
            <v-container>
              <div>
                <div
                  v-if="loading"
                  :style="styleObject"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <v-row v-else>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <div
                      id="idTable"
                      style="overflow-x: auto; max-width: 100%;"
                    >
                      <table
                        style="width: 100%; color: black; border-collapse: collapse;"
                        class="elevation-1"
                      >
                        <thead>
                          <tr>
                            <th
                              v-for="(h, index) in localHeadersDetalhamento"
                              id="dadoMovimentacao"
                              :key="'head-' + index"
                              style="text-align: center;"
                            >
                              {{ h.text }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in localDadosDetalhamento"
                            :key="item.id"
                          >
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.produtor }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: right;"
                            >
                              {{ item.quantidade_anterior }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: right;"
                            >
                              {{ item.quantidade_atual }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: right;"
                            >
                              <v-chip
                                class="text-right"
                                :color="getColor(item.diferenca_anual, 0)"
                                dark
                              >
                                {{ formateNum(item.diferenca_anual) }}
                              </v-chip>
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: right;"
                            >
                              <v-chip
                                class="text-right"
                                :color="getColor(item.varicao_quantidade, 0)"
                                dark
                              >
                                {{ item.varicao_quantidade }}
                              </v-chip>
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: right;"
                            >
                              {{ item.precomedio }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </template>
          <template v-if="componenteValorPie">
            <div>
              <div
                v-if="loading"
                id="carregaDados"
                :style="styleObject"
              >
                <v-icon
                  light
                  :style="styleObject"
                  class="custom-loader"
                >
                  mdi-cached
                </v-icon>
                Carregando Dados...
              </div>
              <div
                v-else-if="error"
                class="alert alert-danger"
              >
                {{ error }}
              </div>
              <div>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <div
                      id="valor"
                      class="text-right"
                      :style="styleObject"
                    >
                      {{ valor }}
                    </div>
                  </v-col>
                </v-row>
                <canvas
                  :id="graficoId"
                  class="text-center"
                  width="70"
                  height="50"
                />
                <span
                  v-if="exibirTituloGrafico"
                  :id="tituloId"
                  class="text-center"
                >
                  {{ title }}
                </span>
              </div>
            </div>
          </template>
          <template v-if="componenteValorPie2">
            <div>
              <div
                v-if="loading"
                id="carregaDados"
                :style="styleObject"
              >
                <v-icon
                  light
                  :style="styleObject"
                  class="custom-loader"
                >
                  mdi-cached
                </v-icon>
                Carregando Dados...
              </div>
              <div
                v-else-if="error"
                class="alert alert-danger"
              >
                {{ error }}
              </div>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <div
                    id="valor"
                    :style="styleObject"
                    class="text-center"
                    style="margin: -3rem 0 0 0rem;"
                  >
                    <v-row class="text-center">
                      <v-col
                        id="metaFaturamento"
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                        class="text-left"
                      >
                        <v-row id="mesFaturamento">
                          <v-col
                            v-if="!loading"
                            id="textoFaturamento"
                            cols="12"
                            sm="4"
                            md="4"
                            lg="4"
                            class="text-left"
                          >
                            Faturamento
                          </v-col>
                          <v-col
                            v-if="!loading"
                            id="valorMetaFaturamento"
                            cols="12"
                            sm="8"
                            md="8"
                            lg="8"
                            class="text-right"
                          >
                            {{ valor }}
                          </v-col>
                          <canvas
                            :id="graficoId"
                            class="text-center"
                            width="70"
                            height="50"
                          />
                          <span
                            v-if="exibirTituloGrafico && !loading"
                            :id="tituloFaturamentoMeta"
                            class="text-center percent"
                          >
                            {{ title }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col
                        id="metaVolume"
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                        class="text-left"
                      >
                        <v-row id="mesVolume">
                          <v-col
                            v-if="!loading"
                            id="textoFaturamento"
                            cols="12"
                            sm="4"
                            md="4"
                            lg="4"
                            class="text-left"
                          >
                            Volume
                          </v-col>
                          <v-col
                            v-if="!loading"
                            id="valorMetaVolume"
                            cols="12"
                            sm="8"
                            md="8"
                            lg="8"
                            class="text-right"
                          >
                            {{ valor2 }}
                          </v-col>
                          <canvas
                            :id="graficoId2"
                            class="text-center"
                            width="70"
                            height="50"
                          />
                          <span
                            v-if="exibirTituloGrafico && !loading"
                            :id="tituloVolumeMeta"
                            class="text-center percent"
                          >
                            {{ title2 }}
                          </span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
  import dadosOrientacao from '../../../../services/menu'

  export default {
    name: 'DashboardCoreCardView',
    props: {
      codeInformation: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      width: {
        type: String,
        default: '',
      },
      textoInformation: {
        type: String,
        default: '',
      },
      styleObject: {
        type: Object,
        default: () => ({}),
      },
      styleObject2: {
        type: Object,
        default: () => ({}),
      },
      valor: {
        type: String,
        default: '',
      },
      valor2: {
        type: String,
        default: '',
      },
      valor3: {
        type: String,
        default: '',
      },
      valor4: {
        type: String,
        default: '',
      },
      valor5: {
        type: String,
        default: '',
      },
      exibirValorPorcentagem: {
        type: Boolean,
        default: false,
      },
      componenteValor: {
        type: Boolean,
        default: false,
      },
      componenteValorFaturamento: {
        type: Boolean,
        default: false,
      },
      componenteValorColuna: {
        type: Boolean,
        default: false,
      },
      componenteGrafico: {
        type: Boolean,
        default: false,
      },
      componenteAuxiliar: {
        type: Boolean,
        default: false,
      },
      graficoId: {
        type: String,
        default: '',
      },
      graficoId2: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      title2: {
        type: String,
        default: '',
      },
      dadosGrafico: {
        type: Object,
        default: () => ({}),
      },
      dadosGrafico2: {
        type: Object,
        default: () => ({}),
      },
      tituloId: {
        type: String,
        default: '',
      },
      exibirTituloGrafico: {
        type: Boolean,
        default: false,
      },
      exibirDadosGrafico: {
        type: Boolean,
        default: false,
      },
      legendaGrafico: {
        type: Array,
        default: () => [],
      },
      headersDetalhamento: {
        type: Array,
        default: () => [],
      },
      dadosDetalhamento: {
        type: Array,
        default: () => [],
      },
      exibirLegenda: {
        type: Boolean,
        default: false,
      },
      exibirTextoTitulo: {
        type: Boolean,
        default: false,
      },
      lengendaValorMoterio: {
        type: Boolean,
        default: false,
      },
      valorExibicao: {
        type: String,
        default: '',
      },
      valorRestante: {
        type: String,
        default: '',
      },
      valorExibicao2: {
        type: String,
        default: '',
      },
      valorRestante2: {
        type: String,
        default: '',
      },
      enableGraficoValorMonetario: {
        type: Boolean,
        default: false,
      },
      componenteDiasUteis: {
        type: Boolean,
        default: false,
      },
      diasUteis: {
        type: String,
        default: '0',
      },
      diasPecorrido: {
        type: String,
        default: '0',
      },
      padding: {
        type: String,
        default: '',
      },
      routerLinkPositivados: {
        type: String,
        default: '',
      },
      routerLinkAtivos: {
        type: String,
        default: '',
      },
      textPositivados: {
        type: String,
        default: '',
      },
      textAtivos: {
        type: String,
        default: '',
      },
      totalPositivados: {
        type: Number,
        default: 0,
      },
      totalAtivos: {
        type: Number,
        default: 0,
      },
      exibirInformacao: {
        type: Boolean,
        default: true,
      },
      exibirDadosClientes: {
        type: Boolean,
        default: false,
      },
      variacaoDiferenca: {
        type: Boolean,
        default: false,
      },
      variacaoQtd: {
        type: Boolean,
        default: false,
      },
      exibirIcone: {
        type: Boolean,
        default: false,
      },
      linkDetalhe: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      exibirDetalheFinanceiro: {
        type: Boolean,
        default: false,
      },
      componenteValorPie: {
        type: Boolean,
        default: false,
      },
      componenteValorPie2: {
        type: Boolean,
        default: false,
      },
      tituloFaturamentoMeta: {
        type: String,
        default: '',
      },
      tituloVolumeMeta: {
        type: String,
        default: '',
      },
      valorFaturamentoIcmsst: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      codigo: '',
      error: null,
      styleObjectvalorRestante: {
        color: '#ed934f',
      },
      stylePositivados: {
        color: '#ed934f',
      },
      teste: '28px !important',
      headersCopy: [],
      textoOrientacao: '',
    }),

    computed: {
      localHeadersDetalhamento () {
        return [...this.headersDetalhamento]
      },
      localDadosDetalhamento () {
        return [...this.dadosDetalhamento]
      },
    },

    watch: {
      codeInformation: function (val) {
        this.codeInformation = val
      },

      text: function (val) {
        this.text = val
      },

      width: function (val) {
        this.width = val
      },

      textoInformation: function (val) {
        this.textoInformation = val
      },

      styleObject: function (val) {
        this.styleObject = val
      },

      styleObject2: function (val) {
        this.styleObject2 = val
      },

      valor: function (val) {
        this.valor = val
      },

      valor2: function (val) {
        this.valor2 = val
      },

      valor3: function (val) {
        this.valor3 = val
      },

      valor4: function (val) {
        this.valor4 = val
      },

      valor5: function (val) {
        this.valor5 = val
      },

      exibirValorPorcentagem: function (val) {
        this.exibirValorPorcentagem = val
      },

      componenteValor: function (val) {
        this.componenteValor = val
      },

      componenteValorFaturamento: function (val) {
        this.componenteValorFaturamento = val
      },

      componenteValorColuna: function (val) {
        this.componenteValorColuna = val
      },

      componenteGrafico: function (val) {
        this.componenteGrafico = val
      },
      componenteAuxiliar: function (val) {
        this.componenteAuxiliar = val
      },

      graficoId: function (val) {
        this.graficoId = val
      },

      graficoId2: function (val) {
        this.graficoId = val
      },

      dadosGrafico: function (val) {
        this.dadosGrafico = val
      },

      dadosGrafico2: function (val) {
        this.dadosGrafico2 = val
      },

      title: function (val) {
        this.title = val
      },

      title2: function (val) {
        this.title2 = val
      },

      tituloId: function (val) {
        this.tituloId = val
      },

      exibirTituloGrafico: function (val) {
        this.enableTituloGrafico = val
      },

      legendaGrafico: function (val) {
        this.legendaGrafico = val
      },
      exibirLegenda: function (val) {
        this.exibirLegenda = val
      },

      exibirTextoTitulo: function (val) {
        this.exibirTextoTitulo = val
      },

      lengendaValorMoterio: function (val) {
        this.lengendaValorMoterio = val
      },

      valorExibicao: function (val) {
        this.valorExibicao = val
      },

      valorRestante: function (val) {
        this.valorRestante = val
      },

      valorExibicao2: function (val) {
        this.valorExibicao = val
      },

      valorRestante2: function (val) {
        this.valorRestante = val
      },

      enableGraficoValorMonetario: function (val) {
        this.enableGraficoValorMonetario = val
      },

      componenteDiasUteis: function (val) {
        this.componenteDiasUteis = val
      },

      diasUteis: function (val) {
        this.diasUteis = val
      },

      diasPecorrido: function (val) {
        this.diasPecorrido = val
      },

      padding: function (val) {
        this.padding = val
      },

      routerLinkPositivados: function (val) {
        this.routerLinkPositivados = val
      },

      routerLinkAtivos: function (val) {
        this.routerLinkAtivos = val
      },

      textPositivados: function (val) {
        this.textPositivados = val
      },

      textAtivos: function (val) {
        this.textAtivos = val
      },

      positivados: function (val) {
        this.positivados = val
      },

      ativos: function (val) {
        this.ativos = val
      },

      exibirInformacao: function (val) {
        this.exibirInformacao = val
      },

      exibirDadosClientes: function (val) {
        this.exibirDadosClientes = val
      },

      variacaoDiferenca: function (val) {
        this.variacaoDiferenca = val
      },

      variacaoQtd: function (val) {
        this.variacaoQtd = val
      },

      exibirIcone: function (val) {
        this.exibirIcone = val
      },

      linkDetalhe: function (val) {
        this.linkDetalhe = val
      },

      loading: function (val) {
        this.loading = val
      },

      exibirDetalheFinanceiro: function (val) {
        this.exibirDetalheFinanceiro = val
      },

      componenteValorPie: function (val) {
        this.componenteValorPie = val
      },

      componenteValorPie2: function (val) {
        this.componenteValorPie2 = val
      },

      tituloFaturamentoMeta: function (val) {
        this.tituloFaturamentoMeta = val
      },

      tituloVolumeMeta: function (val) {
        this.tituloVolumeMeta = val
      },

      valorFaturamentoIcmsst: function (val) {
        this.valorFaturamentoIcmsst = val
      },
    },

    created () {
    },

    beforeDestroy () {
    },

    methods: {
      async enableText (value) {
        await dadosOrientacao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value).then(resposta => {
          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao

            this.codigo = value
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.message === 'Permissão para a pagina não encontrada, metodo 8') {
            this.$router.push('/dashboard')
          }
        })
      },

      handleEnableLoading (value) {
        this.loading = value
      },

      handleDisableLoading (loading) {
        this.loading = loading
      },

      handleDisableLoadingGrafico (loading) {
        this.loading = loading
      },

      getColor (value, mediador) {
        var porcentagem = value
        if (typeof value === 'string') {
          porcentagem = parseFloat(value.replace(',', '.'))
        }

        return porcentagem >= mediador ? 'color: green' : 'color: red'
      },

      formateNum (num) {
        return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
      },
    },

  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #titulo2 {
      margin: 0 0 0 16rem !important;
      display: grid;
    }

    #myChart2 {
      margin: -5.5rem 0 0 16rem;
      display: grid;
    }

    #pieFatxMetaComercial6 {
      margin: -5.5rem 0 1rem 8rem;
      display: grid;
    }

    #tituloFatxMetaComercial6 {
      margin: -2rem 0 0 -8.5rem
    }

    #pieChartComercial6 {
      margin: -4.5rem 0 0 14rem
    }

    #pieChartVolumeMeta {
      margin: -5.1rem 0 3rem 14rem
    }

    #faturamentoMeta7 {
      margin: -1.5rem 0 0 -6rem
    }

    #volumeMeta7 {
      margin: -2rem 0 0 -6rem
    }

    #valorMetaFaturamento {
      margin: -3.5rem 0 0 0
    }

    #valorMetaVolume {
      margin: -4rem 0 0 0
    }

    #titulo2Comercial6 {
      margin: -2rem 0 0 -8.5rem
    }

    #myChart3 {
      margin: -6rem 0 0 14rem !important;
    }

    #titulo3 {
      margin: -1rem 0 0 12rem !important;
      display: grid;
    }

    #titulo4 {
      margin: -1rem 0 0 12rem !important;
      display: grid;
    }

    #myChart4 {
      margin: -6rem 0 0 14rem !important;
    }

    #tituloPieLeite {
      margin: 0 0 0 16rem !important;
    }

    #myChartPieLeite1 {
      margin: -6rem 0 0 14rem !important;
    }

    #tituloPieLeite1 {
      margin: -1rem 0 0 12rem !important;
    }

    #myChartPieLeite2 {
      margin: -6rem 0 0 14rem !important;
    }

    #tituloPieLeite2 {
      margin: -1rem 0 0 12rem !important;
    }

    #myChartAnaliseComparativoFaturamentoMes {
      width: 370px !important;
      height: 280px !important;
      margin: 0 0 0 -1rem
    }

    #myChartKgTotalClassificacaoVendedor {
      width: 320px !important;
      height: 270px !important;
    }

    #textoFaturamento {
      display: flex
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #titulo2 {
      font-size: 16px;
      margin: -2rem 0 0 5rem;
      display: grid;
    }

    #textoFaturamento {
      display: flex
    }

    #myChart2 {
      margin: -4.5rem 0 0 10.5rem !important;
      display: grid;
    }

    #myChart3 {
      margin: -4.5rem 0 0 12rem !important;
    }

    #myChart4 {
      margin: -4.5rem 0 0 12rem !important;
    }

    #cardIdComponente {
      margin: 0rem 0 0 0rem !important;
    }
  }

  @media screen and (min-width: 1380px) and (max-width: 1499px) {
    #myChart2 {
      margin: -4.5rem 0 0 9.5rem;
      display: grid;
    }

    #titulo2 {
      margin: -2rem 0 0 8.5rem;
    }

    #pieFatxMetaComercial6 {
     margin: -5.5rem 0 1rem 1rem;
      display: grid;
    }

    #tituloFatxMetaComercial6 {
      margin: -2rem 0 0 -11rem
    }

    #pieChartComercial6 {
     margin: -4.5rem 0 0 1rem;
      display: grid;
    }

    #titulo2Comercial6 {
      margin: -2rem 0 0 -4.5rem
    }

    #myChart3 {
      margin: -5rem 0 0 10.5rem !important;
    }

    #titulo3 {
      margin: -1.8rem 0 0 10rem !important;
    }

    #myChart4 {
      margin: -4.5rem 0 0 10.5rem !important;
    }

    #titulo4 {
      margin: -2rem 0 0 10rem !important;
    }

    #myChartPieComercialLeite {
      margin: -4.5rem 0 0 10.5rem;
    }

    #tituloPieLeite {
      margin: -2rem 0 0 9.5rem;
    }

    #myChartPieLeite1 {
      margin: -5rem 0 0 10rem !important;
    }

    #tituloPieLeite1 {
      margin: -1.8rem 0 0 9rem !important;
    }

    #myChartPieLeite2 {
      margin: -5rem 0 0 10rem !important;
    }

    #tituloPieLeite2 {
      margin: -2rem 0 0 9rem !important;
    }
  }

  @media screen and (min-width: 1500px) and (max-width: 1599px) {
    #myChart2 {
      margin: -4.5rem 0 0 10rem;
      display: grid;
    }

    #titulo2 {
      margin: -2rem 0 0 8.5rem;
    }

    #pieFatxMetaComercial6 {
     margin: -5.5rem 0 1rem 1rem;
      display: grid;
    }

    #tituloFatxMetaComercial6 {
      margin: -2rem 0 0 -11rem
    }

    #pieChartComercial6 {
     margin: -4.5rem 0 0 1rem;
      display: grid;
    }

    #titulo2Comercial6 {
      margin: -2rem 0 0 -4.5rem
    }

    #myChart3 {
      margin: -5rem 0 0 10.5rem !important;
    }

    #titulo3 {
      margin: -1.8rem 0 0 10rem !important;
    }

    #myChart4 {
      margin: -4.5rem 0 0 10.5rem !important;
    }

    #titulo4 {
      margin: -2rem 0 0 10rem !important;
    }

    #myChartPieComercialLeite {
      margin: -4.5rem 0 0 10.5rem;
    }

    #tituloPieLeite {
      margin: -2rem 0 0 9.5rem;
    }

    #myChartPieLeite1 {
      margin: -5rem 0 0 10rem !important;
    }

    #tituloPieLeite1 {
      margin: -1.8rem 0 0 9rem !important;
    }

    #myChartPieLeite2 {
      margin: -5rem 0 0 10rem !important;
    }

    #tituloPieLeite2 {
      margin: -2rem 0 0 9rem !important;
    }
  }

  @media screen and (min-width: 1600px) and (max-width: 1800px) {
    #myChart2 {
      margin: -4.5rem 0 0 11rem;
      display: grid;
    }

    #titulo2 {
      margin: -2rem 0 0 8.5rem;
    }

    #pieFatxMetaComercial6 {
     margin: -5.5rem 0 1rem 1rem;
      display: grid;
    }

    #tituloFatxMetaComercial6 {
      margin: -2rem 0 0 -11rem
    }

    #pieChartComercial6 {
     margin: -4.5rem 0 0 1rem;
      display: grid;
    }

    #titulo2Comercial6 {
      margin: -2rem 0 0 -4.5rem
    }

    #myChart3 {
      margin: -5rem 0 0 12rem !important;
    }

    #titulo3 {
      margin: -1.8rem 0 0 10rem !important;
    }

    #myChart4 {
      margin: -4.5rem 0 0 12rem !important;
    }

    #titulo4 {
      margin: -2rem 0 0 10rem !important;
    }

    #myChartPieComercialLeite {
      margin: -4.5rem 0 0 11rem;
    }

    #tituloPieLeite {
      margin: -2rem 0 0 9.5rem;
    }

    #myChartPieLeite1 {
      margin: -5rem 0 0 13rem !important;
    }

    #tituloPieLeite1 {
      margin: -1.8rem 0 0 13rem !important;
    }

    #myChartPieLeite2 {
      margin: -4.5rem 0 0 13rem !important;
    }

    #tituloPieLeite2 {
      margin: -2rem 0 0 13rem !important;
    }
  }

  @media screen
  and (min-width: 1801px) {
    #myChart2 {
      margin: -4.5rem 0 0 16rem
    }

    #titulo2 {
      margin: -2rem 0 0 13.5rem
    }

    #pieFatxMetaComercial6 {
      margin: -5rem 0 1rem 8rem
    }

    #tituloFatxMetaComercial6 {
      margin: -2rem 0 0 -6rem
    }

    /* #tituloValorPie {
      margin: -2rem 0 0 10.5rem
    } */

    #pieChartComercial6 {
      margin: -4.5rem 0 0 10rem
    }

    #pieChartVolumeMeta {
      margin: -5.1rem 0 3rem 10rem
    }

    #faturamentoMeta7 {
      margin: -1.5rem 0 0 -6rem
    }

    #volumeMeta7 {
      margin: -2rem 0 0 -6rem
    }

    #valorMetaFaturamento {
      margin: 0 0 0 0
    }

    #valorMetaVolume {
      margin: 0 0 0 0
    }

    #titulo2Comercial6 {
      margin: -5rem 0 0 -5.5rem
    }

    #tituloValorPie {
      margin: -2rem 0 0 10.5rem
    }

    #myChart3 {
      margin: -5rem 0 0 17rem !important
    }

    #titulo3 {
      margin: -1.8rem 0 0 15.5rem !important
    }

    #myChart4 {
      margin: -4.5rem 0 0 17rem
    }

    #titulo4 {
      margin: -2rem 0 0 15.5rem
    }

    #myChartPieComercialLeite {
      margin: -4.5rem 0 0 16rem
    }

    #tituloPieLeite {
      margin: -2rem 0 0 13.5rem
    }

    #myChartPieLeite1 {
      margin: -5rem 0 0 17rem !important
    }

    #tituloPieLeite1 {
      margin: -1.8rem 0 0 15.5rem !important
    }

    #myChartPieLeite2 {
      margin: -5.5rem 0 0 17rem
    }

    #tituloPieLeite2 {
      margin: -1rem 0 0 15.5rem
    }

    #textoFaturamento {
      display: flex
    }
  }

</style>

<style scoped>
  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #cardIdComponente {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .highlighted-item {
    background-color: #FAFAFA;
    padding: 16px 20px;
    color: balck;
    margin: -1rem 0 0 0;
    border-radius: 20px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 425px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }

    #iconInformation {
      margin: -5rem 0 0 0;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }
</style>

<style lang="sass">
  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

  #iconInformation
    margin: 0 0 0 0

  #valor
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin: -3rem 0 0 0

  #valor1
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin: -4.5rem 0 0 0

  #valor2
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin: -3rem 0 0 0

  #myChart
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    width: 750
    height: 330

  #myChart2
    margin: -4.5rem 0 0 8rem
    display: grid
    width: 110px !important
    height: 73px !important

  #titulo2
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -2rem 0 0 7.5rem

  #pieFatxMetaComercial6
    margin: -5.5rem 0 1rem 1rem
    display: grid
    width: 110px !important
    height: 73px !important

  #tituloFatxMetaComercial6
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -2rem 0 0 -10rem

  #pieChartComercial6
    margin: -4.5rem 0 0 1rem
    display: grid
    width: 110px !important
    height: 73px !important

  #faturamentoMeta7
    margin: -1rem 0 0 -5.6rem

  #valorMetaFaturamento
    margin: 0.5rem 0 0rem 7rem

  #pieChartVolumeMeta
    margin: -4.5rem 0 0 1rem
    display: grid
    width: 110px !important
    height: 73px !important

  #volumeMeta7
    margin: -0.5rem 0 3rem -6rem

  #valorMetaVolume
    margin: 1rem 0 0rem 7rem

  #titulo2Comercial6
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -2rem 0 0 -4rem

  #tituloValorPie
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -2rem 0 0 7.5rem

  #statusCor
    font-size: 10px

  #legendaAberta
    margin: 1rem 0 0 0

  #myChart3
    font-size: 20px
    margin: -5rem 0 0 8rem !important
    display: grid
    width: 110px !important
    height: 73px !important

  #titulo3
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -1.8rem 0 0 7.5rem !important

  #myChart4
    font-size: 20px
    margin: -5.5rem 0 0 8rem
    display: grid
    width: 110px !important
    height: 73px !important

  #titulo4
    font-size: 16px
    display: grid
    align-items: center
    margin: -1rem 0 0 7.5rem
    font-weight: bold

  #valorRestante
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold

  #valorRestanteExibicao
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin-top: 6rem

  #valorExibicao
    font-size: 14px
    display: grid
    align-items: center
    font-weight: bold
    margin-top: -8rem

  #textoDias
    font-size: 14px
    display: grid
    align-items: center
    margin: -3rem 0 0 0
    font-weight: bold

  #textoDiasTrabalhado
    font-size: 14px
    display: grid
    align-items: center
    margin: -3rem 0 0 0
    font-weight: bold

  #diasUteis
    font-size: 18px
    font-weight: bold
    margin: -3rem 0 0 0

  #diasPecorrido
    font-size: 18px
    font-weight: bold
    margin: -3rem 0 0 0

  #myChartPedidoDiaADia
    width: 100vh
    height: 100vh

  #titulo5
    font-size: 18px
    display: grid
    align-items: center
    font-weight: bold
    margin: --2rem 0 19px -0.5rem

  #statusPerso
    font-size: 10px

  #positivados
    font-size: 22px
    font-weight: bold

  #myChartFaturamentoLinha
    margin: -2.5rem 0 0 0

  #myChartFaturamentoPrecoMedioClassificacaoVendedores
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0 0 0 -1rem

  #myChartFaturamentoMetaVendedorClassificacao
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold

  #myChartFaturamentoRedesKg
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold

  #myChartFaturamentoRedesRS
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold

  #myChartPieComercialLeite
    margin: -4.5rem 0 0 8rem
    display: grid
    width: 110px !important
    height: 73px !important

  #tituloPieLeite
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -2rem 0 0 7.5rem

  #myChartPieLeite1
    font-size: 20px
    margin: -5rem 0 0 8rem !important
    display: grid
    width: 110px !important
    height: 73px !important

  #tituloPieLeite1
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: -1.8rem 0 0 7.5rem !important

  #myChartPieLeite2
    font-size: 20px
    margin: -5.5rem 0 0 8rem
    display: grid
    width: 110px !important
    height: 73px !important

  #tituloPieLeite2
    font-size: 16px
    display: grid
    align-items: center
    margin: -1rem 0 0 7.5rem
    font-weight: bold

  .v-application .pr-15
    padding-right: 26px !important

  #myChartAnaliseComparativoFaturamentoMes
    // width: 1100px !important
    // height: 700px !important

  #mesAtual
    font-size: 18px
    font-weight: bold

  #mesVolume
    font-size: 18px
    font-weight: bold
    margin: 1.5rem 0 -3rem 0

  #mesFaturamento
    font-size: 18px
    font-weight: bold
    margin: -1rem 0 -1rem 0

  #mesAnterior
    font-size: 15px
    opacity: 0.6

  #metaFaturamento
    margin: 1rem 0 0 0

  #metaVolume
    margin: 0rem 0 0 0

  #textoFaturamento
    display: none

  .percent
    font-size: 13px

  @media only screen and (max-width: 480px)
    .v-application .pr-15
      padding-right: 8rem !important

</style>
